var _defs, _g, _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 1280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 20px;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 24px;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 27px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m545.25,303c37.26,0,72.29,14.51,98.64,40.86,26.35,26.35,40.86,61.38,40.86,98.64s-14.51,72.29-40.86,98.64c-26.35,26.35-61.38,40.86-98.64,40.86s-72.29-14.51-98.64-40.86c-26.35-26.35-40.86-61.38-40.86-98.64s14.51-72.29,40.86-98.64c26.35-26.35,61.38-40.86,98.64-40.86m0-27c-91.96,0-166.5,74.54-166.5,166.5s74.54,166.5,166.5,166.5,166.5-74.54,166.5-166.5-74.54-166.5-166.5-166.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m765.62,799h-167.62v249h-274.75v-222c0-122.61,99.39-222,222-222,61.31,0,116.81,24.85,156.98,65.02,34.18,34.19,57.27,79.47,63.39,129.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 329,
    y: 394,
    width: 59,
    height: 119,
    rx: 22.18,
    ry: 22.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 703,
    y: 394,
    width: 59,
    height: 119,
    rx: 22.58,
    ry: 22.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m358.5,394c3.21-14.09,19.45-78.4,82.5-120,9.06-5.97,58.6-37.55,123-31,77.17,7.85,145.05,67.33,174.34,151"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "598 1048 445.6 1048 598 1091 1032 1091 1032 799 765.62 799"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1097.08,513h-258.16c-23.15,0-41.92,18.77-41.92,41.92v98.16c0,23.15,18.77,41.92,41.92,41.92h42.21c-.88,16.17-1.75,32.33-2.63,48.5,29.83-16.17,59.67-32.33,89.5-48.5h129.08c23.15,0,41.92-18.77,41.92-41.92v-98.16c0-23.15-18.77-41.92-41.92-41.92Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 853,
    y1: 580.5,
    x2: 1089,
    y2: 580.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 853,
    y1: 622.5,
    x2: 1089,
    y2: 622.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live-chat.958d7afd8ef3f26d4a90f3d30bb4a00c.svg";
export { ForwardRef as ReactComponent };